import { useEffect, useState } from 'react';
import { Icon } from './Icon.tsx';

type Theme = 'light' | 'dark';
const STORAGE_KEY = 'wapoffice.theme';

function getInitial(): Theme {
  if (typeof window === 'undefined') return 'light';
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function apply(theme: Theme): void {
  document.documentElement.classList.toggle('dark', theme === 'dark');
}

export function ThemeToggle(): JSX.Element {
  const [theme, setTheme] = useState<Theme>(() => getInitial());

  useEffect(() => {
    apply(theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  return (
    <button
      onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
      className="inline-flex items-center justify-center rounded-full size-11 text-muted-foreground hover:bg-muted/70 transition-colors"
    >
      <Icon name={theme === 'dark' ? 'light_mode' : 'dark_mode'} size={22} />
    </button>
  );
}
